var datumName = "WGS 84";
var a: any;
var eccSquared: any;
var status: boolean = false;

export function init(datumNameIn) {
  if (datumNameIn !== undefined) {
    datumName = datumNameIn;
  }
  setEllipsoid(datumName);
}

export function convertLatLngToUtm(latitude, longitude, precision): any {
  if (status) {
    return 'No ellipsoid data associated with unknown datum: ' + datumName;
  }

  if (!Number.isInteger(precision)) {
    return 'Precision is not integer number.';
  }

  latitude = parseFloat(latitude);
  longitude = parseFloat(longitude);

  var LongTemp = longitude;
  var LatRad = toRadians(latitude);
  var LongRad = toRadians(LongTemp);
  var ZoneNumber;

  if (LongTemp >= 8 && LongTemp <= 13 && latitude > 54.5 && latitude < 58) {
    ZoneNumber = 32;
  } else if (latitude >= 56.0 && latitude < 64.0 && LongTemp >= 3.0 && LongTemp < 12.0) {
    ZoneNumber = 32;
  } else {
    ZoneNumber = ((LongTemp + 180) / 6) + 1;

    if (latitude >= 72.0 && latitude < 84.0) {
      if (LongTemp >= 0.0 && LongTemp < 9.0) {
        ZoneNumber = 31;
      } else if (LongTemp >= 9.0 && LongTemp < 21.0) {
        ZoneNumber = 33;
      } else if (LongTemp >= 21.0 && LongTemp < 33.0) {
        ZoneNumber = 35;
      } else if (LongTemp >= 33.0 && LongTemp < 42.0) {
        ZoneNumber = 37;
      }
    }
  }
  ZoneNumber = parseInt(ZoneNumber);

  var LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3;  //+3 puts origin in middle of zone
  var LongOriginRad = toRadians(LongOrigin);

  var UTMZone = getUtmLetterDesignator(latitude);

  var eccPrimeSquared = (eccSquared) / (1 - eccSquared);

  var N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
  var T = Math.tan(LatRad) * Math.tan(LatRad);
  var C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
  var A = Math.cos(LatRad) * (LongRad - LongOriginRad);

  var M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad
    - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad)
    + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad)
    - (35 * eccSquared * eccSquared * eccSquared / 3072) * Math.sin(6 * LatRad));

  var UTMEasting = (0.9996 * N * (A + (1 - T + C) * A * A * A / 6
    + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120)
    + 500000.0);

  var UTMNorthing = (0.9996 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24
    + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720)));

  if (latitude < 0)
    UTMNorthing += 10000000.0;
  UTMNorthing = precisionRound(UTMNorthing, precision);
  UTMEasting = precisionRound(UTMEasting, precision);
  return { Easting: UTMEasting, Northing: UTMNorthing, ZoneNumber: parseInt(ZoneNumber), ZoneLetter: UTMZone };
};

export function convertUtmToLatLng(UTMEasting, UTMNorthing, UTMZoneNumber, UTMZoneLetter): any {
  var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
  var x = UTMEasting - 500000.0; //remove 500,000 meter offset for longitude
  var y = UTMNorthing;
  var ZoneNumber = UTMZoneNumber;
  var ZoneLetter = UTMZoneLetter;
  var NorthernHemisphere;
  if (UTMEasting === undefined) {
    return "Please pass the UTMEasting!";
  }
  if (UTMNorthing === undefined) {
    return "Please pass the UTMNorthing!";
  }
  if (UTMZoneNumber === undefined) {
    return "Please pass the UTMZoneNumber!";
  }
  if (UTMZoneLetter === undefined) {
    return "Please pass the UTMZoneLetter!";
  }

  if (['N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'].indexOf(ZoneLetter) !== -1) {
    NorthernHemisphere = 1;
  } else {
    NorthernHemisphere = 0;
    y -= 10000000.0;
  }

  var LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3;

  var eccPrimeSquared = (eccSquared) / (1 - eccSquared);

  var M = y / 0.9996;
  var mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));

  var phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu)
    + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu)
    + (151 * e1 * e1 * e1 / 96) * Math.sin(6 * mu);
  var phi1 = toDegrees(phi1Rad);

  var N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
  var T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
  var C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
  var R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
  var D = x / (N1 * 0.9996);

  var Lat = phi1Rad - (N1 * Math.tan(phi1Rad) / R1) * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24
    + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
  Lat = toDegrees(Lat);

  var Long = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1)
    * D * D * D * D * D / 120) / Math.cos(phi1Rad);
  Long = LongOrigin + toDegrees(Long);
  return { lat: Lat, lng: Long };
};

function getUtmLetterDesignator(latitude) {
  latitude = parseFloat(latitude);
  if ((84 >= latitude) && (latitude >= 72))
    return 'X';
  else if ((72 > latitude) && (latitude >= 64))
    return 'W';
  else if ((64 > latitude) && (latitude >= 56))
    return 'V';
  else if ((56 > latitude) && (latitude >= 48))
    return 'U';
  else if ((48 > latitude) && (latitude >= 40))
    return 'T';
  else if ((40 > latitude) && (latitude >= 32))
    return 'S';
  else if ((32 > latitude) && (latitude >= 24))
    return 'R';
  else if ((24 > latitude) && (latitude >= 16))
    return 'Q';
  else if ((16 > latitude) && (latitude >= 8))
    return 'P';
  else if ((8 > latitude) && (latitude >= 0))
    return 'N';
  else if ((0 > latitude) && (latitude >= -8))
    return 'M';
  else if ((-8 > latitude) && (latitude >= -16))
    return 'L';
  else if ((-16 > latitude) && (latitude >= -24))
    return 'K';
  else if ((-24 > latitude) && (latitude >= -32))
    return 'J';
  else if ((-32 > latitude) && (latitude >= -40))
    return 'H';
  else if ((-40 > latitude) && (latitude >= -48))
    return 'G';
  else if ((-48 > latitude) && (latitude >= -56))
    return 'F';
  else if ((-56 > latitude) && (latitude >= -64))
    return 'E';
  else if ((-64 > latitude) && (latitude >= -72))
    return 'D';
  else if ((-72 > latitude) && (latitude >= -80))
    return 'C';
  else
    return 'Z';

};

function setEllipsoid(name) {
  switch (name) {
    case 'Airy':
      a = 6377563;
      eccSquared = 0.00667054;
      break;
    case 'Australian National':
      a = 6378160;
      eccSquared = 0.006694542;
      break;
    case 'Bessel 1841':
      a = 6377397;
      eccSquared = 0.006674372;
      break;
    case 'Bessel 1841 Nambia':
      a = 6377484;
      eccSquared = 0.006674372;
      break;
    case 'Clarke 1866':
      a = 6378206;
      eccSquared = 0.006768658;
      break;
    case 'Clarke 1880':
      a = 6378249;
      eccSquared = 0.006803511;
      break;
    case 'Everest':
      a = 6377276;
      eccSquared = 0.006637847;
      break;
    case 'Fischer 1960 Mercury':
      a = 6378166;
      eccSquared = 0.006693422;
      break;
    case 'Fischer 1968':
      a = 6378150;
      eccSquared = 0.006693422;
      break;
    case 'GRS 1967':
      a = 6378160;
      eccSquared = 0.006694605;
      break;
    case 'GRS 1980':
      a = 6378137;
      eccSquared = 0.00669438;
      break;
    case 'Helmert 1906':
      a = 6378200;
      eccSquared = 0.006693422;
      break;
    case 'Hough':
      a = 6378270;
      eccSquared = 0.00672267;
      break;
    case 'International':
      a = 6378388;
      eccSquared = 0.00672267;
      break;
    case 'Krassovsky':
      a = 6378245;
      eccSquared = 0.006693422;
      break;
    case 'Modified Airy':
      a = 6377340;
      eccSquared = 0.00667054;
      break;
    case 'Modified Everest':
      a = 6377304;
      eccSquared = 0.006637847;
      break;
    case 'Modified Fischer 1960':
      a = 6378155;
      eccSquared = 0.006693422;
      break;
    case 'South American 1969':
      a = 6378160;
      eccSquared = 0.006694542;
      break;
    case 'WGS 60':
      a = 6378165;
      eccSquared = 0.006693422;
      break;
    case 'WGS 66':
      a = 6378145;
      eccSquared = 0.006694542;
      break;
    case 'WGS 72':
      a = 6378135;
      eccSquared = 0.006694318;
      break;
    case 'ED50':
      a = 6378388;
      eccSquared = 0.00672267;
      break; // International Ellipsoid
    case 'WGS 84':
    case 'EUREF89': // Max deviation from WGS 84 is 40 cm/km see http://ocq.dk/euref89 (in danish)
    case 'ETRS89': // Same as EUREF89 
      a = 6378137;
      eccSquared = 0.00669438;
      break;
    default:
      status = true;

  }
};

function toDegrees(rad) {
  return rad / Math.PI * 180;
};

function toRadians(deg) {
  return deg * Math.PI / 180;
};

function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
}
